<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage organization</h1>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div v-if="!statusSucceed && organizationId" class="container">
            <div class="form-group">
                <label>Name:</label>
                <input v-model="name" type="text" class="form-control" placeholder="Name of workspace">
                <ValidationError context="Name" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label>Description:</label>
                <textarea v-model="description" class="form-control" placeholder="Description of workspace"></textarea>
                <ValidationError context="Description" :errors="validationErrors"></ValidationError>
            </div>

            <button v-if="!statusInvoking" @click="invokeUpdateOrganizationUnitCommandV1" type="button" class="btn btn-primary btn-lg">Save</button>
            <button v-else type="button" class="btn btn-primary btn-lg" disabled>Saving...</button>
        </div>

        <div v-else-if="statusSucceed" class="container">
            <h4>Congratulation! Organization was updated.</h4>
            <a class="btn btn-primary btn-lg" :href="`/#/admin/organizations/dashboard/${tid}`" role="button">Go to dashboard</a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from '@common/Components/ValidationError.vue'

    import { useOrganizationUnitQueryV1 } from '@Organizations/OrganizationUnits/queries-vue-composables'
    import { useUpdateOrganizationUnitCommandV1 } from '@Organizations/OrganizationUnits/commands-vue-composables'

    // ---------------- route ----------------

    const route = useRoute()

    const tid = computed(() => Number(route.params.tid))

    // ---------------- local state ----------------

    const name = ref('')
    const description = ref('')

    // ---------------- query ----------------

    const {
        modelOrganizationUnitQueryV1: organizationUnit,
        runOrganizationUnitQueryV1
    } = useOrganizationUnitQueryV1(tid)

    // ---------------- command ----------------

    const {
        invokeUpdateOrganizationUnitCommandV1,
        invokingUpdateOrganizationUnitCommandV1,
        succeedUpdateOrganizationUnitCommandV1,
        validationErrorsUpdateOrganizationUnitCommandV1
    } = useUpdateOrganizationUnitCommandV1(
        computed(() => organizationUnit.value?.Id),
        name,
        description
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Manage organization'
        runOrganizationUnitQueryV1()
    })

    // ---------------- sync read model → form ----------------

    watch(organizationUnit, (ou) =>
    {
        if (!ou) return

        name.value = ou.Name
        description.value = ou.Description
    }, { immediate: true })

    // ---------------- derived ----------------

    const organizationId = computed(() =>
        organizationUnit.value?.Id
    )

    const statusInvoking = computed(() =>
        invokingUpdateOrganizationUnitCommandV1.value
    )

    const statusSucceed = computed(() =>
        succeedUpdateOrganizationUnitCommandV1.value
    )

    const validationErrors = computed(() =>
        validationErrorsUpdateOrganizationUnitCommandV1.value
    )
</script>
